import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Landing from "@/pages/Landing";
import Success from "@/pages/Success";
import WeeklyQELanding from "@/pages/WeeklyQELanding";
import WeeklyQEWelcome from "@/pages/WeeklyQEWelcome";
import WeeklyQEAdmin from "@/pages/WeeklyQEAdmin";

// Fires a Meta Pixel PageView on every React Router client-side navigation.
// The initial PageView is already fired inline in public/index.html.
function MetaPixelPageTracker() {
  const location = useLocation();
  const isFirstRender = React.useRef(true);
  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return; // skip — index.html already fired PageView on load
    }
    if (typeof window !== "undefined" && typeof window.fbq === "function") {
      window.fbq("track", "PageView");
    }
  }, [location.pathname]);
  return null;
}

function App() {
  return (
    <BrowserRouter>
      <MetaPixelPageTracker />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/success" element={<Success />} />
        <Route path="/weeklyqe" element={<WeeklyQELanding />} />
        <Route path="/weeklyqe/welcome" element={<WeeklyQEWelcome />} />
        <Route path="/weeklyqe/admin" element={<WeeklyQEAdmin />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
